import React from "react";
import { StyleSheet, View } from "react-native";
import { ChartBarIcon, ClipboardTextIcon, ClockIcon, GraduationCapIcon } from "@phosphor-icons/react";

import MetricCard from "../../../../../components/adminDashboard/Analytics/components/MetricCard";
import Pill from "../../../../../components/common/Pill/Pill";
import { colors, spacing } from "../../../../../styles/design-system";

interface RosterInsightSummaryMetricsProps {
  runningGrade: string;
  hasLowGrade: boolean;
  gradedCount: number;
  totalSubmissions: number;
  missingCount: number;
  lateSubmissionsCount: number;
}

const RosterInsightSummaryMetrics = ({
  runningGrade,
  hasLowGrade,
  gradedCount,
  totalSubmissions,
  missingCount,
  lateSubmissionsCount,
}: RosterInsightSummaryMetricsProps) => {
  return (
    <View style={styles.metricsRow}>
      <MetricCard
        icon={<GraduationCapIcon size={20} color={colors.grey[600]} weight="fill" />}
        value={runningGrade}
        label="Running Grade"
        trend={hasLowGrade ? "down" : undefined}
        trendColor={colors.error[600]}
        valueColor={hasLowGrade ? colors.error[600] : colors.grey[900]}
        style={styles.metricCard}
      />

      <MetricCard
        icon={<ChartBarIcon size={20} color={colors.grey[600]} weight="fill" />}
        value={gradedCount.toString()}
        subValue={totalSubmissions > 0 ? `/${totalSubmissions}` : undefined}
        label="Graded"
        style={styles.metricCard}
      />

      <MetricCard
        icon={<ClipboardTextIcon size={20} color={colors.grey[600]} weight="fill" />}
        value={missingCount.toString()}
        label="Missing"
        valueColor={missingCount > 0 ? colors.error[600] : colors.grey[900]}
        style={styles.metricCard}
        headerRight={
          missingCount > 0 ? (
            <Pill text="Action needed" backgroundColor={colors.error[50]} textColor={colors.error[600]} textSize="xs" />
          ) : undefined
        }
      />

      <MetricCard
        icon={<ClockIcon size={20} color={colors.grey[600]} weight="fill" />}
        value={lateSubmissionsCount.toString()}
        label="Late Submissions"
        valueColor={lateSubmissionsCount > 0 ? colors.warning[800] : colors.grey[900]}
        style={styles.metricCard}
      />
    </View>
  );
};

const styles = StyleSheet.create({
  metricsRow: {
    flexDirection: "row",
    flexWrap: "wrap",
    gap: spacing.md,
  },
  metricCard: {
    flexGrow: 1,
    flexBasis: 0,
    minWidth: 220,
  },
});

export default RosterInsightSummaryMetrics;
